module.exports = __webpack_public_path__ + "img/logo_contago_erp.7f382023.png";